import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { createTheme, ThemeProvider } from '@material-ui/core/styles'
import { LoginProvider } from './common/LoginContext'
import { MissionPackProvider } from './common/MissionPackContext'
import { SnackbarProvider } from 'notistack'

var mode = 'light'

const colors = {
  primary: '#4CAF50',
  secondary: '#F4D038',
  tertiary: '#1F2933',
  quaternary: '#394049',
  accent: '#B1A296',
  outlinedTextField: {
    disabled: {
      label: '#9B9B9B',
    },
    unfocused: {
      label: 'black',
      border: 'black',
    },
    focused: {
      label:'black',
      border: 'black',
    },
    hovered: {
      label: 'black',
      border: 'black',
    },
  },
  skuCard: {
    body: '#f5f5f5',
    footer: '#616E7C',
    text: 'white',
    header: '#f0f0f0',
  },
}

const theme = createTheme({
  palette: {
    type: mode,
    primary: {
      main: colors.quaternary,
    },
    custom: colors,
  },
})

ReactDOM.render(
  <React.StrictMode>
    <SnackbarProvider>
      <MissionPackProvider>
        <LoginProvider>
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </LoginProvider>
      </MissionPackProvider>
    </SnackbarProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
